import { parseTemperature, useTranslation } from '@fareye/common'
import { labelColor, valueColor } from '@fareye/configs'
import { isNullUndefinedAndEmpty, toTileCase } from '@fareye/utils'
import React from 'react'
import { MMStopsDetails } from '../../style/styled'
import { FieldValue } from './FieldValue'
import { displayTimeSecondFormat } from './function'

export function CurrentDetails({ rowData, positionStyle }: any) {
  const { t } = useTranslation()
  let {
    eta,
    status,
    lastLocation,
    currentLocation,
    latestJourney,
    transporterName,
    transportMode,
    vehicleNo,
    vesselNo,
    vesselName
  } = rowData || {}
  let { landmark, speed, extraData } = lastLocation || currentLocation || {}
  if (latestJourney) {
    landmark = latestJourney?.latestLocation?.landmark
    speed = latestJourney?.latestLocation?.speed
    transporterName = latestJourney?.transporterName
    vehicleNo = latestJourney?.vehicleNo
    vesselNo = latestJourney?.vesselNo
    vesselName = latestJourney?.vesselName
    transportMode = latestJourney?.transportMode
  }
  function fieldRenderingOnTransporterMode(mode: string) {
    switch (mode) {
      case 'road':
        return (
          <>
            <FieldValue
              style={{
                marginBottom: 4,
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}
              labelStyle={{
                color: labelColor,
                marginBottom: 2
              }}
              label={t('VehicleNo')}
              value={vehicleNo}
              valueStyle={{
                color: valueColor,
                textTransform: 'uppercase'
              }}
            />
          </>
        )
      case 'ocean':
        return (
          <>
            <FieldValue
              style={{
                marginBottom: 4,
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}
              labelStyle={{
                color: labelColor,
                marginBottom: 2
              }}
              label={t('Vessel No')}
              value={vesselNo}
              valueStyle={{ color: valueColor }}
            />
            <FieldValue
              style={{
                marginBottom: 4,
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}
              labelStyle={{
                color: labelColor,
                marginBottom: 2
              }}
              label={t('Vessel Name')}
              value={vesselName}
              valueStyle={{ color: valueColor }}
            />
          </>
        )
      case 'air':
      case 'rail':
      default:
        return (
          <>
            <FieldValue
              style={{
                marginBottom: 4,
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}
              labelStyle={{
                color: labelColor,
                marginBottom: 2
              }}
              label={t('VehicleNo')}
              value={vehicleNo}
              valueStyle={{ color: valueColor }}
            />
          </>
        )
    }
  }
  let speedStr = `${isNullUndefinedAndEmpty(speed) ? '-' : speed + ' Km/hr'}`
  let temperature = parseTemperature(
    extraData?.temperature ?? extraData?.sensorData
  )
  return (
    <MMStopsDetails style={{ ...positionStyle }} className="popover">
      {status ? (
        <FieldValue
          style={{ marginBottom: 4 }}
          labelStyle={{ color: labelColor }}
          label={`${t('Status')}: `}
          value={t(status) || '-'}
        />
      ) : null}
      <FieldValue
        style={{ marginBottom: 4 }}
        labelStyle={{ color: labelColor }}
        valueStyle={{ color: valueColor }}
        label={t('Speed')}
        value={speedStr}
      />
      {temperature ? (
        <FieldValue
          style={{ marginBottom: 4 }}
          labelStyle={{ color: labelColor }}
          valueStyle={{ color: valueColor }}
          label={t('Temperature')}
          value={temperature}
        />
      ) : null}

      {extraData?.tampering ? (
        <FieldValue
          style={{ marginBottom: 4 }}
          labelStyle={{ color: labelColor }}
          valueStyle={{ color: valueColor }}
          label={t('Temp Sensor')}
          value={extraData?.tampering ? 'Tampered' : 'No Tampering'}
        />
      ) : null}

      <FieldValue
        style={{ marginBottom: 4 }}
        labelStyle={{ color: labelColor }}
        valueStyle={{ color: valueColor }}
        label="Eta"
        value={`${displayTimeSecondFormat(eta)}`}
      />
      <hr />
      <FieldValue
        style={{
          marginBottom: 4,
          flexDirection: 'column',
          alignItems: 'flex-start'
        }}
        labelStyle={{
          color: labelColor,
          marginBottom: 2
        }}
        label={t('Current Location')}
        valueStyle={{ color: valueColor }}
        value={toTileCase(landmark)}
      />
      <FieldValue
        style={{
          marginBottom: 4,
          flexDirection: 'column',
          alignItems: 'flex-start'
        }}
        labelStyle={{
          color: labelColor,
          marginBottom: 2
        }}
        valueStyle={{ color: valueColor }}
        label={t('Current Carrier')}
        value={toTileCase(transporterName)}
      />
      {fieldRenderingOnTransporterMode(transportMode)}
    </MMStopsDetails>
  )
}
